import React from 'react'

const Fifty_six = () => {
    return (
        <div className='container'>
            <h1>C - Recursion</h1>
           
           <p> Recursion is the process of repeating items in a self-similar way.
             In programming languages, if a program allows you to call a function
              inside the same function, then it is called a recursive call of the 
              function.
          </p>
            <div className='containers'>
          <code className='keywords'> void</code> recursion() &#123; <br />
   recursion(); <br /><code className='comment'>/* function calls itself */ </code><br />
&#125;<br />
<br />
<code className='keywords'>int</code> main() &#123;<br />
   recursion();
&#125;
            </div>
        </div>
    )
}

export default Fifty_six
